import BossModel from "@/models/BossModel";
import Airline from "@/models/Airline/Airline";

export default class Classification extends BossModel {

    static apiUrl = 'dossier/ticket/flight/classification';

    static entity = 'dossierTicketFlightClassifications';

    static fields() {
        return {
            id: this.number(null).nullable(),
            airline_id: this.number(null).nullable(),
            code: this.attr(null),
            name: this.attr(null),
            airline: this.belongsTo(Airline, 'airline_id'),
        }
    }
}
